import * as React from "react";
import {translate} from "react-i18next";
import {Header} from "../../components/Header";
import TextBody from "../../components/TextBody";
import {Container,Row,Col} from "reactstrap";
import BottomBar from "../../components/BottomBar";
import TopNav from "../../components/TopNav";
import moment from "moment";
import {formatDateForBottomBar, getWeekdayFromDate} from "../../DateHelper";
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import "../../vodafone.css"
import MomentLocaleUtils from 'react-day-picker/moment';
import 'moment/locale/de';
import {SpacerRow} from "../../components/SpacerRow";
import SubPageTopBar from "../../components/SubPageTopBar";
import {BrowserView,MobileView,isMobile} from "react-device-detect";
import TextField from '@material-ui/core/TextField';
import vodafoneLogo from "../../media/icons/vf-logo.png";
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import i18n from "i18next";
import iconError from "../../media/icons/error.svg";
import {MOMENT_TECHNICIAN_APPOINTMENT_DATE_FORMAT_ONLY_WEEKDAY} from "../../common";

class StageAppointmentSelectVerify extends React.Component {

    // initialize Component state
    state = { warningMessageBox: false, warningTextYesAtHome: false, warningTextNoAtHome: false };

    constructor(props){
        super(props);
         this.state = {
             selectedOption: '',
			 redButtonDisabled: true
         }
    }


    /**
     * handle radio button on change
     * @param e
     */
    handleOnChange = (e) =>  {
        console.log('selected option', e.target.value);
        this.setState({ selectedOption: e.target.value});
    }


    /**
     * update Message
     * @param event
     */
    updateMessage = (event) => {

        console.log("updateMessage / event.target.id: " + event.target.id);
        console.log("updateMessage / state.warningMessageBox: " + this.state.warningMessageBox);
        console.log('selected option', event.target.value);
		
		this.state.redButtonDisabled = false;

        this.setState({ selectedOption: event.target.value});

        // set warningMessageBox: true so that message box will be shown
        if( event.target.id == "yesAtHome" ) {
            // setState triggers another execution of "render()" method
            this.setState({warningMessageBox: true});
            this.setState({warningTextYesAtHome: true});
            this.setState({warningTextNoAtHome: false});

        // set warningMessageBox: false so that message box will be hidden
        } else {
            // setState triggers another execution of "render()" method
            this.setState({warningMessageBox: false});
            this.setState({warningTextYesAtHome: false});
            this.setState({warningTextNoAtHome: true});
        }
    };


    /**
     * Open "Klingelschild"-PDF
     */
    showKlingelschild = () => {
        var urlPath = "";
        if( window.location.pathname ) {
            urlPath = "/" + window.location.pathname.substring(0, window.location.pathname.lastIndexOf("/"));
        }
        window.open(window.location.origin + urlPath + "/img/Vodafone_Klingelschild_Technikertermin.pdf"  );
    };


    /**
     * render
     * @returns {*}
     */
    render() {

        var verify_title                = "verify_title_placeholder";
        var verify_body                 = "verify_body_placeholder";
		var verify_body2				= "";
        var verify_button               = "verify_button_placeholder";
        var verify_radio_buttons        = "verify_radio_buttons_placeholder";
        var verify_klingelschild_button = "verify_klingelschild_button_placeholder";
		var verify_emoji_wink			= "";

        // select text/elements depending on TAM (RESULT_CODE)
        switch( parseInt( this.props.ds360APIResult.RESULT_CODE ) ) {

            // setze Texte für TAM6000 und TAM6002 (sind identisch; keine Radio-Buttons)
            case 6000:
            case 6002:
                verify_title            = "tam6000_calendar_confirm_title";
                verify_body             = "tam6000_calendar_confirm_body";
                verify_button           = "tam6000_calendar_confirm_button";
                verify_radio_buttons    = "";
                verify_klingelschild_button = "";
				this.state.redButtonDisabled = false;
				
                break;

            // setze Text und Radio-Buttons für TAM6001
            case 6001:
                verify_title            = "tam6001_calendar_confirm_title";
                verify_body             = "tam6001_calendar_confirm_body";
				verify_body2            = "tam6001_calendar_confirm_body_2";
                verify_button           = "tam6001_calendar_confirm_button";
                verify_klingelschild_button = "";
                verify_radio_buttons = 
                        <FormControl className={"width-100 myRadioGroup"}>
                            <RadioGroup>
                                <FormControlLabel onClick={this.updateMessage} value={"yes"} control={<Radio id="yesAtHome" />} label={i18n.t("answer_1_1_after_appointment_select")} className={ `${this.state.selectedOption === "yes" ? 'radio_active' : 'radio_inactive'}` } > </FormControlLabel>
                                <div className={this.state.warningMessageBox ? "warningMessageContainer show" : "warningMessageContainer"}>
                                    <Row style={{paddingBottom:"20px"}}>
                                        <Col xs={{size: 12}}>
                                            <div class="warningMessage">
                                                <Row>
                                                    <Col xs={{size: 12}} className={this.state.warningTextYesAtHome ? "yesAtHome show" : "yesAtHome"}>
                                                        <TextBody
                                                            textResource={"zusammenfassung_warning_after_appointment_select_yes"}
                                                        />
                                                    </Col>
                                                    <Col xs={{size: 10}} className={this.state.warningTextNoAtHome ? "noAtHome show" : "noAtHome"}>
                                                        <TextBody
                                                            textResource={"zusammenfassung_warning_after_appointment_select_no"}
                                                        />
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                                <FormControlLabel onClick={this.updateMessage} value={"no"} control={<Radio id="noAtHome" />} label={i18n.t("answer_1_2_after_appointment_select")} className={ `${this.state.selectedOption === "no" ? 'radio_active' : 'radio_inactive'}` } > </FormControlLabel>
                            </RadioGroup>
                        </FormControl>;
                break;

            // setze Text und Radio-Buttons für TAM6003 (Texte wie bei TAM6000)
            case 6003:
                verify_title            = "tam6003_calendar_confirm_title";
                verify_body             = "tam6003_calendar_confirm_body";
                verify_button           = "tam6003_calendar_confirm_button";
                verify_radio_buttons    = "";
				verify_emoji_wink		= "&#128521;";
                verify_klingelschild_button = <BottomBar
                    showBackButtonValidation={true}
                    mainButtonOnClick={() => {
                        this.showKlingelschild();
                    }}
                    backButtonValidationOnClick={true}
                    backValidationButtonTextResource={"tam6003_calendar_confirm_klingeschild_button"}
                />;
				this.state.redButtonDisabled = false;
        }

        return <Container>
            <MobileView>
                <Row className={"header"}>
                        <Col xs={2} style={{marginLeft:"-15px"}}>
                            <img src={vodafoneLogo} className={"img-fluid"}  alt={"Vodafone Logo"}/>
                        </Col>
                    </Row>
                <Row style={{paddingTop:"5vh"}}>
                    <Col xs={{ size: 12 }}>
                            <Header
                                textResource={verify_title}
                            />
                    </Col>
                </Row>
                <Row style={{paddingTop:"20px"}}>
                    <Col xs={{ size: 12 }}>
                            <TextBody
                                textResource={verify_body}
								emoji_wink="&#128521;"
                            />
							<TextBody
                                textResource={verify_body2}
                            />
                    </Col>
                </Row>
                <Row className={'fixed-to-bottom'} style={{paddingBottom:"165px"}}>
                    <Col xs={{ size: 12 }}>
                        {verify_klingelschild_button}
						{verify_radio_buttons}
						<Row>
                            <Col xs={{ size: 12 }}>
                                <Row>
                                    <Col xs={{ size: 12 }} className="verticalAlign">
                                        <div class="selectedAppointmentContainer">
                                            <Row>
                                                <Col xs={{ size: 7 }} className="verticalAlign">
                                                    <img class="img-fluid technikerImg" src="img/techniker.png" />
													<TextBody
                                                        textResource={"select_appointment_label"}
                                                    />
                                                </Col>
                                                <Col xs={{ size: 5 }}>
                                                    {moment.utc(this.props.selectedDate).format("dddd")},&nbsp;
                                                    {moment.utc(this.props.selectedDate).format("DD.MM.")}<br />
                                                    {moment.utc(this.props.selectedDate).format("H")} - {moment.utc(this.props.selectedDate).add(5, 'hours').format("H")} Uhr
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row className={"fixed-to-bottom"} style={{paddingBottom: "50px"}}>
                            <Col xs={{ size: 12 }} className={"twoButtons"} style={{paddingTop:"20px"}}>
                                <BottomBar
                                    mainButtonOnClick={() => {
                                        this.state.apiAction = "appointment";
                                        this.props.saveUserDataToCCApi( this.state );
                                        this.props.commonSubmitCallback( this.state.selectedOption );
                                    }}
                                    mainButtonTextResource={verify_button}
                                    disabled = {this.state.redButtonDisabled}
                                />
								<BottomBar
									showBackButtonValidation={true}
                                    mainButtonOnClick={() => {
										// go back one stage using MainPage.js->commonSubmitCallback()
										this.props.commonSubmitCallback("goBackOneStage")
                                    }}
                                    backButtonValidationOnClick={true}
                                    backValidationButtonTextResource={"select_technician_appointment_back"}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </MobileView>

            <BrowserView>
                <Row className={"header desktop"}>
						<Col xs={12}>
							<div className={"container"}>
								<Row>
									<Col xs={2} style={{marginLeft:"-15px"}}>
										<img src={vodafoneLogo} className={"img-fluid"}  alt={"Vodafone Logo"}/>
									</Col>
								</Row>
							</div>
						</Col>
                    </Row>
				<Row style={{paddingTop:"20vh"}}>
                    <Col xs={{ size: 10, offset: 1 }}>
                            <Header
                                textResource={verify_title}
                            />
                    </Col>
                </Row>
                <Row style={{paddingTop:"20px"}}>
                    <Col xs={{ size: 10, offset: 1 }}>
                            <TextBody
                                textResource={verify_body}
								emoji_wink="&#128521;"
                            />
							<TextBody
                                textResource={verify_body2}
                            />
                    </Col>
                </Row>
				<Row style={{paddingTop:"20px"}}>
                    <Col xl={{ size: 2, offset: 1 }} lg={{ size: 3, offset: 1 }} md={{ size: 4, offset: 1 }} sm={{ size: 6, offset: 1 }} xs={{ size: 12, offset: 0 }} >
						{verify_klingelschild_button}
					</Col>
				</Row>
				<Row>
                    <Col xs={{ size: 10, offset: 1 }}>
						{verify_radio_buttons}
					</Col>
				</Row>
                <Row>
                    <Col xs={{ size: 10, offset: 1 }}>
                        <Row>
                            <Col xs={{ size: 12 }} className="verticalAlign">
                                <div class="selectedAppointmentContainer">
                                    <Row>
                                        <Col xs={{ size: 2 }} className="verticalAlign">
                                            <img class="img-fluid technikerImg" src="img/techniker.png" />
											<TextBody
                                                textResource={"select_appointment_label"}
                                            />
                                        </Col>
                                        <Col xs={{ size: 5 }}>
                                            {moment.utc(this.props.selectedDate).format("dddd")},&nbsp;
                                            {moment.utc(this.props.selectedDate).format("DD.MM.")}<br />
                                            {moment.utc(this.props.selectedDate).format("H")} - {moment.utc(this.props.selectedDate).add(5, 'hours').format("H")} Uhr
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col xl={{ size: 1, offset: 1 }} lg={{ size: 1, offset: 1 }} md={{ size: 2, offset: 1 }} sm={{ size: 2, offset: 1 }} xs={{ size: 12, offset: 0 }} className="verticalAlign">
                        <BottomBar
                            showBackButtonValidation={true}
                            mainButtonOnClick={() => {
                                // go back one stage using MainPage.js->commonSubmitCallback()
                                this.props.commonSubmitCallback("goBackOneStage")
                            }}
                            backButtonValidationOnClick={true}
                            backValidationButtonTextResource={"select_technician_appointment_back"}
                        />
                    </Col>
					<Col xl={{ size: 3, offset: 0 }} lg={{ size: 3, offset: 0 }} md={{ size: 5, offset: 0 }} sm={{ size: 6, offset: 0 }} xs={{ size: 12, offset: 0 }} style={{paddingTop:"20px"}}>
						<div style={{paddingTop:"15px"}}>
							<BottomBar
								mainButtonOnClick={() => {
									this.state.apiAction = "appointment";
								    this.props.saveUserDataToCCApi( this.state );
								    this.props.commonSubmitCallback( this.state.selectedOption );
								}}
								mainButtonTextResource={verify_button}
								disabled = {this.state.redButtonDisabled}
							/>
						</div>
                    </Col>
					
                </Row>
            </BrowserView>
        </Container>
    }
}

export default translate("translations")(StageAppointmentSelectVerify);